<template>
    <AdminLayout>
      <MainIndex />
      <div class="pb-16"></div>
    </AdminLayout>
  </template>
<script>
import AdminLayout from '@/layouts/AdminLayout.vue';
import MainIndex from '@/components/admin/campaign/MainIndex.vue';

export default {
  name: 'MassCommunicationView',
  components: {
    AdminLayout,
    MainIndex,
  },
};
</script>
